import React, { useCallback, useState } from 'react';
import { MOBILE_SCREEN } from 'consts';
import { useStore } from 'effector-react';
import { useMatchMedia } from 'hooks/useMatchMedia';
import { currProduct$ } from 'models/product';
import CalendarModal from 'pages/Product/CalendarModal';
import MobileCalendarModal from 'pages/Product/MobileCalendarModal';
import { useGetDatesSuggestions } from 'pages/Product/useGetDatesSuggestions';
import { formatDate, getFormattedHireDates } from 'utils/datesСalculation';

import DatePickerDisclosureItem from './DatePickerDisclosureItem';

import { Row, T8y } from 'ui';

import { ReactComponent as DatePickerIcon } from 'assets/images/icons/calendarIcon.svg';

import style from './datesPanel.module.scss';

const DatesPanel = ({
  selectingDetails = {},
  setSelectingDetails,
  handleAddProduct,
  handleScrollToEnquiryClick,
  isMaxQuantityReached,
  isMakeAnEnquiryOnly,
  calculatedPrice,
  isDatesHighlighted,
  setIsDatesHighlighted,
  datesRef,
}) => {
  const isMobile = useMatchMedia(`(max-width: ${MOBILE_SCREEN}px)`);
  const product = useStore(currProduct$);

  const suggestions = useGetDatesSuggestions(product);

  const [isCalendarModalOpen, setIsCalendarModalOpen] = useState(false);

  const { startDate, endDate } = getFormattedHireDates(
    'en-gb',
    selectingDetails.dates?.start,
    selectingDetails.dates?.end,
  );

  const handleDatesChange = useCallback(
    (selectedValues) => {
      setSelectingDetails((currDetails) => ({
        ...currDetails,
        dates: {
          start: formatDate(selectedValues.startDate),
          end: formatDate(selectedValues.endDate),
        },
      }));
    },
    [setSelectingDetails],
  );

  return (
    <div className={style.priceDatesTitles}>
      <Row justify="stretch" className={style.titlesItems}>
        <T8y
          as="span"
          variant="t3"
          xsVariant="t1"
          color="wilkoBlack"
          bold
          mr
          inline
        >
          Hire Period
        </T8y>
        {isMobile && <DatePickerIcon />}
      </Row>
      <div
        className={style.dateItems}
        onClick={() => {
          setIsCalendarModalOpen(true);
        }}
        ref={datesRef}
      >
        <DatePickerDisclosureItem
          date={!!selectingDetails.dates?.start && startDate}
          titleSlug="hireStart"
          isDatesHighlighted={isDatesHighlighted}
        />
        <DatePickerDisclosureItem
          date={!!selectingDetails.dates?.end && endDate}
          titleSlug="hireEnd"
          isDatesHighlighted={isDatesHighlighted}
        />
        {isCalendarModalOpen && isMobile && (
          <MobileCalendarModal
            selectingDetails={selectingDetails}
            setSelectingDetails={setSelectingDetails}
            setIsCalendarModalOpen={setIsCalendarModalOpen}
            handleAddProduct={handleAddProduct}
            handleScrollToEnquiryClick={handleScrollToEnquiryClick}
            isMaxQuantityReached={isMaxQuantityReached}
            isMakeAnEnquiryOnly={isMakeAnEnquiryOnly}
            calculatedPrice={calculatedPrice}
            isDatesHighlighted={isDatesHighlighted}
            setIsDatesHighlighted={setIsDatesHighlighted}
            suggestions={suggestions}
          />
        )}
        {isCalendarModalOpen && !isMobile && (
          <CalendarModal
            product={product}
            dates={selectingDetails.dates}
            setIsCalendarModalOpen={setIsCalendarModalOpen}
            handleDatesChange={handleDatesChange}
            isDatesHighlighted={isDatesHighlighted}
            suggestions={suggestions}
          />
        )}
      </div>
    </div>
  );
};

export default DatesPanel;
